<template>
  <CatalogueMobile v-if="$vuetify.breakpoint.smAndDown"/>
  <CatalogueDesktop v-else/>
</template>

<script>
import CatalogueMobile from "../components/catalogue/CatalogueMobile";
import CatalogueDesktop from "../components/catalogue/CatalogueDesktop";
import store from "@/store";

export default {
  name: "Catalogue",
  components: {
    CatalogueDesktop,
    CatalogueMobile,
  },
  metaInfo() {
    return {
      title: 'Collection',
    }
  },
  created() {
    if (!store.state.catalogue.merchantItems.length) store.dispatch('catalogue/merchantItems');
  },
  beforeDestroy() {
    const { searching, filtering } = this.$store.state.catalogue
    if (searching) this.$store.commit("catalogue/cancelSearch")
    if (filtering) this.$store.commit("catalogue/cancelFilter")
  }
}
</script>

